import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/model_version_log_audits',
  component: Management,
  redirect: '/model_version_log_audits/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/model_version_log_audits/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listModelVersionLogAudits
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/model_version_log_audits/ListTable'),
          meta: {
            auth: Auth.listModelVersionLogAudits,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/model_version_log_audits/DetailLayout'),
      meta: {
        auth: Auth.showModelVersionLogAudit
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/model_version_log_audits/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showModelVersionLogAudit
          }
        },
        // 历史
        // 基本信息
        {
          path: 'versions',
          component: () => import('@/views/model_version_log_audits/details/Versions'),
          meta: {
            tabName: 'versions', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showModelVersionLogAudit
          }
        }
      ]
    }
  ]
}
